import { render, staticRenderFns } from "./part-list-ordered.vue?vue&type=template&id=897a3892&scoped=true"
import script from "./part-list-ordered.vue?vue&type=script&lang=js"
export * from "./part-list-ordered.vue?vue&type=script&lang=js"
import style0 from "./part-list-ordered.vue?vue&type=style&index=0&id=897a3892&prod&lang=css"
import style1 from "./part-list-ordered.vue?vue&type=style&index=1&id=897a3892&prod&lang=scss"
import style2 from "./part-list-ordered.vue?vue&type=style&index=2&id=897a3892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897a3892",
  null
  
)

export default component.exports